import React from 'react';
import { FDImage, FDPaper, FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { SecondaryActionButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/SecondaryActionButtonRel';
import { dataAttrs } from 'Helpers/Testing';
import useQueryParams from 'Hooks/useQueryParams';
import useMobileLayout from 'Hooks/useMobileLayout';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { SHOW_TAX_LEARN_MORE_QUERY_PARAM } from './LearnMore';

export const AskAnExpertWidget = ({ resource }) => {
  const isMobile = useMobileLayout();
  const theme = useTheme();
  const rel = resource.withRelationship(
    fr.relationships.askAnExpert.name,
    (relation) => relation,
    () => null,
  );
  const [queryParams, setQuery] = useQueryParams();

  if (rel == null) {
    return null;
  }

  const avatarGroup = resource.withRelationship(
    fr.relationships.image.name,
    (imageRel) => (
      <FDImage
        alt={'Facet Tax Experts'}
        height={40}
        src={imageRel.link('related').url()}
        rounded={false}
        alignSelf={'flex-start'}
      />
    ),
    () => null,
  );

  return (
    <FDPaper appearance={'flat'} flex={1} padding={3} minWidth={isMobile ? undefined : theme.dimensions.md}>
      <FDStack direction={'column'} spacing={2}>
        {avatarGroup}
        <MetaControlField attr={'askAnExpertDescription'} />
        <FDStack direction={'row'} spacing={2} wrap>
          <SecondaryActionButtonRel
            alignSelf={'flex-start'}
            relationship={rel}
            {...dataAttrs('tax-dashboard-ask-an-expert')}
          />
          <SecondaryActionButtonRel
            alignSelf={'flex-end'}
            relationship={resource.relationship(fr.relationships.learnMore.name)}
            overrideOnClick={() => {
              queryParams.set(SHOW_TAX_LEARN_MORE_QUERY_PARAM, 'true');
              setQuery(queryParams);
            }}
            {...dataAttrs('tax-dashboard-learn-more')}
          />
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};
